import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { fmtErr } from "@/api";
import { useAuth } from "@/auth";
import { useLang } from "@/i18n";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { LOGO_URL } from "@/components/Header";

export default function LoginPage() {
  const { t } = useLang();
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  if (user) return <Navigate to="/dashboard" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await login(email, password);
      toast.success(t("common.saved"));
      navigate("/dashboard");
    } catch (err) {
      setError(fmtErr(err));
    }
    setBusy(false);
  };

  return (
    <div className="min-h-[70vh] grid grid-cols-1 lg:grid-cols-2" data-testid="login-page">
      <div className="hidden lg:flex flex-col justify-center bg-emerald-950 arabesque px-16 py-20">
        <img src={LOGO_URL} alt="Al Ibtisam" className="h-32 w-auto bg-white rounded-lg p-2 self-start mb-10" />
        <h2 className="font-display text-4xl xl:text-5xl font-bold text-white leading-tight">{t("home.tagline")}</h2>
        <p className="text-emerald-100/70 mt-5 max-w-md">{t("home.sub")}</p>
      </div>

      <div className="flex items-center justify-center px-6 py-16 bg-[#F8F9FA]">
        <div className="w-full max-w-md bg-white rounded-xl border border-emerald-900/10 shadow-sm p-8 sm:p-10">
          <h1 className="font-display text-3xl sm:text-4xl font-bold text-emerald-950">{t("auth.login_title")}</h1>
          <p className="text-sm text-slate-600 mt-2 mb-8">{t("auth.login_sub")}</p>
          <form onSubmit={submit} className="space-y-5" data-testid="login-form">
            <div>
              <Label htmlFor="login-email" className="text-sm font-medium text-slate-700">{t("auth.email")}</Label>
              <Input id="login-email" data-testid="login-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1.5" autoComplete="email" />
            </div>
            <div>
              <Label htmlFor="login-password" className="text-sm font-medium text-slate-700">{t("auth.password")}</Label>
              <Input id="login-password" data-testid="login-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="mt-1.5" autoComplete="current-password" />
            </div>
            {error && <p className="text-sm text-red-600" data-testid="login-error">{error}</p>}
            <Button type="submit" disabled={busy} className="w-full rounded-full bg-emerald-800 hover:bg-emerald-900 h-11" data-testid="login-submit-button">
              {busy ? t("common.loading") : t("auth.masuk")}
            </Button>
            <p className="text-center text-sm text-slate-500">
              {t("auth.no_account")}{" "}
              <Link to="/daftar" className="font-semibold text-emerald-800 hover:underline" data-testid="login-register-link">
                {t("auth.register_here")}
              </Link>
            </p>
          </form>
        </div>
      </div>
    </div>
  );
}
